import { HttpClientResponse } from "@microsoft/sp-http"
import { ShowDialog } from "./DialogHelper";


export namespace ErrorHelper {

    export const PnPjsErrorWrapper = async (LOG_SOURCE: string, func: () => Promise<any>) => {
        try {
            return await func();
        } catch (e) {
            console.error(LOG_SOURCE + ": " + e);
            try {
                if (typeof e === "object") {
                    if ((<HttpClientResponse>e).bodyUsed != null) {
                        const json: { Message: string, Title: string, StackTrace: string } = await (<HttpClientResponse>e).json();
                        ShowDialog(`Unexpected Error (${LOG_SOURCE})`, json.Message + "\n\n" + json.StackTrace);
                    } else {
                        ShowDialog(`Unexpected Error (${LOG_SOURCE})`, (typeof e === "object" && e !== null && "message" in e) ? (e as any).message : "An unknown error occurred.");
                    }
                }
            } catch (e) {
                ShowDialog(`Unexpected Error (${LOG_SOURCE})`, "An unexpected error occurred while processing the error.");
            }
            throw e
        }
    }
}